export default "__VITE_ASSET__5065db12__"